/* knowledge-carousel.tsx generated by @compiled/babel-plugin v0.38.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./knowledge-carousel.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Fragment, useEffect, useRef, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import { useDebouncedCallback } from 'use-debounce';
import { IconButton } from '@atlaskit/button/new';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
export var messages = defineMessages({
  scrollLeft: {
    id: 'search_ai.knowledge_carousel.scroll_left',
    defaultMessage: 'Scroll left',
    description: 'Label for the scroll left button'
  },
  scrollRight: {
    id: 'search_ai.knowledge_carousel.scroll_right',
    defaultMessage: 'Scroll right',
    description: 'Label for the scroll right button'
  }
});
var styles = {
  scrollContainerStyle: "_zulppxbi _4cvr1fhb _1e0c1txw _1reo1wug _1fjgglyw _o5721q9c"
};
var isScrollAtLeft = function isScrollAtLeft(elem) {
  return (elem === null || elem === void 0 ? void 0 : elem.scrollLeft) === 0;
};
var isScrollAtRight = function isScrollAtRight(elem) {
  return elem ? Math.abs((elem === null || elem === void 0 ? void 0 : elem.scrollWidth) - (elem === null || elem === void 0 ? void 0 : elem.scrollLeft) - (elem === null || elem === void 0 ? void 0 : elem.clientWidth)) <= 1 : false;
};
var isScrollable = function isScrollable(elem) {
  return elem ? elem.scrollWidth > elem.clientWidth : false;
};
var isScrollAtLeftEdge = function isScrollAtLeftEdge(elem) {
  return elem ? elem.scrollLeft <= 1 : false;
};
var isScrollAtRightEdge = function isScrollAtRightEdge(elem) {
  return elem ? (elem === null || elem === void 0 ? void 0 : elem.scrollWidth) - (elem === null || elem === void 0 ? void 0 : elem.scrollLeft) - (elem === null || elem === void 0 ? void 0 : elem.clientWidth) <= 1 : false;
};
export var KnowledgeCarousel = function KnowledgeCarousel(_ref) {
  var children = _ref.children,
    heading = _ref.heading,
    scrollOffset = _ref.scrollOffset;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var scrollContainerRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shouldHideLeft = _useState2[0],
    setShouldHideLeft = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    shouldHideRight = _useState4[0],
    setShouldHideRight = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    shouldDisableLeftArrowButton = _useState6[0],
    setShouldDisableLeftArrowButton = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    shouldDisableRightArrowButton = _useState8[0],
    setShouldDisableRightArrowButton = _useState8[1];
  useEffect(function () {
    setShouldHideLeft(isScrollAtLeft(scrollContainerRef.current));
    setShouldHideRight(isScrollAtRight(scrollContainerRef.current));
    if (fg('kd_update_sain_carousel_scroll_buttons')) {
      setShouldDisableLeftArrowButton(isScrollAtLeftEdge(scrollContainerRef.current));
      setShouldDisableRightArrowButton(isScrollAtRightEdge(scrollContainerRef.current));
    }
  }, []);
  var _useDebouncedCallback = useDebouncedCallback(function () {
      setShouldHideLeft(isScrollAtLeft(scrollContainerRef.current));
      setShouldHideRight(isScrollAtRight(scrollContainerRef.current));
      setShouldDisableLeftArrowButton(isScrollAtLeftEdge(scrollContainerRef.current));
      setShouldDisableRightArrowButton(isScrollAtRightEdge(scrollContainerRef.current));
    }, 10),
    _useDebouncedCallback2 = _slicedToArray(_useDebouncedCallback, 1),
    onScroll = _useDebouncedCallback2[0];
  var scrollLeft = function scrollLeft() {
    var _scrollContainerRef$c;
    if (fg('kd_update_sain_carousel_scroll_buttons')) {
      setShouldDisableRightArrowButton(false);
    }
    (_scrollContainerRef$c = scrollContainerRef.current) === null || _scrollContainerRef$c === void 0 || _scrollContainerRef$c.scrollBy({
      top: 0,
      left: -scrollOffset,
      behavior: 'smooth'
    });
  };
  var scrollRight = function scrollRight() {
    var _scrollContainerRef$c2;
    if (fg('kd_update_sain_carousel_scroll_buttons')) {
      setShouldDisableLeftArrowButton(false);
    }
    (_scrollContainerRef$c2 = scrollContainerRef.current) === null || _scrollContainerRef$c2 === void 0 || _scrollContainerRef$c2.scrollBy({
      top: 0,
      left: scrollOffset,
      behavior: 'smooth'
    });
  };
  return /*#__PURE__*/React.createElement(Stack, {
    space: "space.150"
  }, /*#__PURE__*/React.createElement(Inline, {
    spread: "space-between",
    alignBlock: "center"
  }, typeof heading === 'string' ? /*#__PURE__*/React.createElement(Text, {
    size: "large",
    weight: "semibold"
  }, heading) : heading, /*#__PURE__*/React.createElement(Inline, {
    space: "space.050"
  }, fg('kd_update_sain_carousel_scroll_buttons') ? isScrollable(scrollContainerRef.current) ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    shape: "circle",
    appearance: "subtle",
    icon: ArrowLeftIcon,
    isTooltipDisabled: true,
    label: formatMessage(messages.scrollLeft),
    onClick: scrollLeft,
    spacing: "compact",
    isDisabled: shouldDisableLeftArrowButton
  }), /*#__PURE__*/React.createElement(IconButton, {
    shape: "circle",
    appearance: "subtle",
    icon: ArrowRightIcon,
    isTooltipDisabled: true,
    label: formatMessage(messages.scrollRight),
    onClick: scrollRight,
    spacing: "compact",
    isDisabled: shouldDisableRightArrowButton
  })) : null : /*#__PURE__*/React.createElement(Fragment, null, !shouldHideLeft && /*#__PURE__*/React.createElement(IconButton, {
    shape: "circle",
    appearance: "subtle",
    icon: ArrowLeftIcon,
    isTooltipDisabled: true,
    label: formatMessage(messages.scrollLeft),
    onClick: scrollLeft,
    spacing: "compact"
  }), !shouldHideRight && /*#__PURE__*/React.createElement(IconButton, {
    shape: "circle",
    appearance: "subtle",
    icon: ArrowRightIcon,
    isTooltipDisabled: true,
    label: formatMessage(messages.scrollRight),
    onClick: scrollRight,
    spacing: "compact"
  })))), /*#__PURE__*/React.createElement(Box, {
    ref: scrollContainerRef,
    onScroll: onScroll,
    xcss: styles.scrollContainerStyle
  }, children));
};